// import SignInForm from "@/components/form/SignInForm";
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SignInForm from "../../components/users/SignInForm";

export const metadata = {
  title: "Avcon | Signin",
  description: "Dynamic Form",
};

function Signin() {
  return (
    <div className=" h-screen ">
      <ToastContainer/>
       <SignInForm/>
    </div>
  );
}

export default Signin;
